{
  "hero": {
    "title": "Leistungen",
    "cta": "Kontakt"
  },
  "banner": {
    "message": "Verfügbar für Fragen und Briefings.",
    "cta": "Kontakt"
  },
  "services": [
    {
      "number": "01",
      "title": "Video- und Fotografieproduktion",
      "description": "Das fehlende Glied in der Unternehmenskommunikation. Hochwertiges Video und Fotografie — Materialien, die die meisten Agenturen dem Kunden überlassen. Die Website wird um den gedrehten Content herum konzipiert.",
      "items": [
        {
          "title": "Unternehmensvideos",
          "description": "Firmen-, Kultur- und Recruitingfilme — klare Materialien für Web und interne Kommunikation.",
          "previewVideo": "corporate"
        },
        {
          "title": "Markengeschichten",
          "description": "Filmische Videos, die das Unternehmen humanisieren.",
          "previewVideo": "povesti-brand"
        },
        {
          "title": "Produktdemos und Erklärvideos",
          "description": "Komplexe Technologie, verständlich aufbereitet.",
          "previewVideo": "demo-produs"
        },
        {
          "title": "Social-First-Vertikalvideo",
          "description": "Hochformat-Reels, Stories und TikTok-Cuts aus einer Drehsession.",
          "previewVideo": "social-first"
        },
        {
          "title": "Produkt- und Lifestyle-Fotografie",
          "description": "Professionelle Aufnahmen für Websites, Kataloge, E-Commerce und Kampagnen.",
          "previewVideo": "fotografie-produs"
        },
        {
          "title": "Vor-Ort- und Eventproduktion",
          "description": "Produktion im Büro, Laden, Weingut oder bei Live-Events.",
          "previewVideo": "filmari-on-location"
        },
        {
          "title": "Asset-Bibliotheken",
          "description": "Monatlicher Bestand an Fotos und Kurzvideos für aktive Kanäle."
        }
      ]
    },
    {
      "number": "02",
      "title": "Brand Engineering",
      "description": "Vom ersten Entwurf bis zum Deployment. Branding wird nicht getrennt behandelt: visuelle Identität und digitaler Auftritt entstehen als ein zusammenhängendes System.",
      "items": [
        {
          "title": "Identitätsdesign",
          "description": "Logos, Typografie und Brand Books, die sich ins Web übertragen lassen."
        },
        {
          "title": "Hochperformante Webentwicklung",
          "description": "Maßgeschneiderte Websites, ausgelegt auf Conversion und Geschwindigkeit."
        },
        {
          "title": "Content-getriebene Websites",
          "description": "Websites, strukturiert um die produzierten Fotos und Videos."
        },
        {
          "title": "Landingpages und Kampagnen-Microsites",
          "description": "Fokussierte Seiten für Launches, Ads, Partnerschaften und Lead-Generierung."
        },
        {
          "title": "Digitale Ökosysteme",
          "description": "Konsistente Markenwirkung — vom Smartphone bis zum Desktop."
        },
        {
          "title": "Visuelle Content-Updates",
          "description": "Aktualisierung der Website mit neuen Produktfotos, Videos und saisonalen Kampagnen."
        }
      ]
    }
  ]
}
